import React, { FC } from "react";
import {
  Box,
  Flex,
  Heading,
  Icon,
  SimpleGrid,
  Text,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { IconType } from "react-icons";
import { RiToolsLine, RiUserUnfollowLine } from "react-icons/ri";

interface HubCardProps {
  title: string;
  description: string;
  to: string;
  icon: IconType;
  accent: string;
}

const HubCard: FC<HubCardProps> = ({ title, description, to, icon, accent }) => {
  return (
    <Box
      as={RouterLink}
      to={to}
      bg="white"
      borderRadius="xl"
      borderWidth="1px"
      borderColor="primary.150"
      p={{ base: 5, md: 6 }}
      _hover={{
        borderColor: accent,
        transform: "translateY(-3px)",
        boxShadow: "md",
      }}
      transition="all 0.18s ease"
      display="block"
      position="relative"
      overflow="hidden"
    >
      <Box
        position="absolute"
        top={0}
        left={0}
        height="3px"
        width="100%"
        bgGradient={`linear(to-r, ${accent}, transparent)`}
      />
      <Flex align="center" gap={4} mb={4}>
        <Flex
          align="center"
          justify="center"
          boxSize="44px"
          borderRadius="lg"
          bg={`${accent}15`}
          color={accent}
        >
          <Icon as={icon} fontSize="22px" />
        </Flex>
        <Heading size="md" color="primary.500" letterSpacing="-0.01em">
          {title}
        </Heading>
      </Flex>
      <Text color="primary.300" mb={4} lineHeight="1.6">
        {description}
      </Text>
      <Text color={accent} fontWeight="medium" fontSize="sm">
        View report →
      </Text>
    </Box>
  );
};

export const AnalyticsHubPage: FC = () => {
  return (
    <Box p={{ base: 4, md: 8 }} maxW="1100px" mx="auto">
      <Box mb={8}>
        <Text
          fontSize="xs"
          textTransform="uppercase"
          letterSpacing="wider"
          color="primary.300"
        >
          Analytics
        </Text>
        <Heading mt={1} size="xl" color="primary.500" letterSpacing="-0.02em">
          Business revenue
        </Heading>
        <Text color="primary.300" mt={2} fontSize="md" maxW="640px">
          What businesses pay LaborHack across the products they use.
        </Text>
      </Box>
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={{ base: 4, md: 6 }}>
        <HubCard
          to="/analytics/maintenance"
          title="Maintenance revenue"
          description="Revenue from facility maintenance requests."
          icon={RiToolsLine}
          accent="#ED6D5C"
        />
        <HubCard
          to="/analytics/talent-unlocks"
          title="Talent unlock revenue"
          description="Revenue from businesses unlocking applicant details."
          icon={RiUserUnfollowLine}
          accent="#003952"
        />
      </SimpleGrid>
    </Box>
  );
};
